// extracted by mini-css-extract-plugin
export default {"avatarContainer":"styles_avatarContainer__F9XDq"};